import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/warehouse-products`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/warehouse-products/${id}?include=organization,product,supplier,warehouse,allowedLocations,taxGroups`,
      options
    )
    .then((response) => {
      let customer = jsona.deserialize(response.data);
      delete customer.links;
      return customer;
    });
}

function add(warehouseProduct) {
  const payload = jsona.serialize({
    stuff: warehouseProduct,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/warehouse-products?include=taxGroups`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(warehouseProduct) {
  const payload = jsona.serialize({
    stuff: warehouseProduct,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/warehouse-products/${warehouseProduct.id}?include=taxGroups`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/warehouse-products/${id}`, options);
}

function bulkCreate(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/warehouse-products/bulk/create`, data, options)
    .then((response) => {
      return response.data;
    });
}

function bulkDelete(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/warehouse-products/bulk/delete`, data, options)
    .then((response) => {
      return response.data;
    });
}

function bulkRefreshPrices(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/warehouse-products/bulk/refresh-prices`, data, options)
    .then((response) => {
      return response.data;
    });
}

function print(params) {
  const options = {
    headers: {},
    responseType: "blob",
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/warehouse-products/print`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  bulkCreate,
  bulkDelete,
  bulkRefreshPrices,
  print,
};
